import { Box, Typography } from "@mui/material";
import LogisticsStageBreakdownList, { FieldLabel } from "./LogisticsStageBreakdownList";

// One asset-type group's card: name + total, "Stage"/"Assets" header row,
// then its stage breakdown. Shared by the compact Insights side panel and
// the Insights dashboard so both render identical group cards.
const LogisticsInsightsTypeGroupCard = ({ typeName, total, stages = [] }) => (
  <Box
    sx={{
      borderRadius: 4,
      backgroundColor: "grey.50",
      overflow: "hidden",
      px: { xs: 1.25, sm: 1.5 },
      pt: 1.25,
      pb: 1.5,
    }}
  >
    <Box sx={{ mb: 1.25 }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "baseline",
          justifyContent: "space-between",
          gap: 1.5,
        }}
      >
        <Typography sx={{ fontSize: 15, fontWeight: 800, color: "text.primary" }}>
          {typeName}
        </Typography>
        <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
          {total} asset{total === 1 ? "" : "s"}
        </Typography>
      </Box>
    </Box>

    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: "minmax(0, 1fr) auto",
        gap: 1.5,
        mb: 1,
      }}
    >
      <FieldLabel>Stage</FieldLabel>
      <Box sx={{ textAlign: "right" }}>
        <FieldLabel>Assets</FieldLabel>
      </Box>
    </Box>

    <LogisticsStageBreakdownList stages={stages} />
  </Box>
);

export default LogisticsInsightsTypeGroupCard;
